// This component is used by both custom pages and initiatives

import React from 'react'
import { Button, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import VisibilityIcon from 'assets/icons/visibility'
import statusThemes from 'config/constants/statusThemes'

const SettingsSummaryBlock = ({
   archived,
   dateLastUpdated,
   entityName,
   onPublishButtonClick,
   onUnarchiveButtonClick,
   onUnpublishButtonClick,
   published,
   textColor,
   updating
}) => {
   let status = published ? 'published' : 'unpublished'

   if (archived) {
      status = 'archived'
   }

   const currentStatus = statusThemes[status]

   return (
      <View
         display="flex"
         width="100%"
         padding="20px"
         backgroundColor={currentStatus.backgroundColor}>
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="24px"
            height="24px"
            backgroundColor={currentStatus.highlightColor}
            borderRadius="50%"
            flex="0 0 auto"
            marginRight="18px">
            <VisibilityIcon
               width="16px"
               height="16px"
               color="#000"
               strokeWidth="2px"
            />
         </View>
         <View flex="1 1 auto">
            <View padding="0px 0px 6px 0px">
               <Text size="1.25" color={textColor}>
                  {`This ${entityName} is:`}
                  <b>{` ${currentStatus.name} `}</b>
               </Text>
            </View>
            <View padding="3px 0px" borderTop={`1px solid ${currentStatus.buttonColor}`}>
               <Text size="1.25" color={textColor}>
                  {`Last updated ${dateLastUpdated}`}
               </Text>
            </View>
            <Spacer size="2" />
            {archived && (
               <Button
                  onClick={onUnarchiveButtonClick}
                  size="sm"
                  width="100%"
                  name="Unarchive"
                  color={currentStatus.buttonColor}
                  textColor={textColor}
                  mode={updating ? 'loading' : 'normal'}
               />
            )}
            {published && !archived && (
               <Button
                  onClick={onUnpublishButtonClick}
                  size="sm"
                  width="100%"
                  name="Unpublish"
                  color={currentStatus.buttonColor}
                  textColor={textColor}
                  mode={updating ? 'loading' : 'normal'}
               />
            )}
            {!published && !archived && (
               <Button
                  onClick={onPublishButtonClick}
                  size="sm"
                  width="100%"
                  name="Publish"
                  color={currentStatus.buttonColor}
                  textColor={textColor}
                  mode={updating ? 'loading' : 'normal'}
               />
            )}
         </View>
      </View>
   )
}

SettingsSummaryBlock.propTypes = {
   archived: PropTypes.bool.isRequired,
   dateLastUpdated: PropTypes.string.isRequired,
   entityName: PropTypes.string.isRequired,
   onPublishButtonClick: PropTypes.func.isRequired,
   onUnarchiveButtonClick: PropTypes.func.isRequired,
   onUnpublishButtonClick: PropTypes.func.isRequired,
   published: PropTypes.bool.isRequired,
   textColor: PropTypes.string,
   updating: PropTypes.bool
}

SettingsSummaryBlock.defaultProps = {
   textColor: '#000',
   updating: false
}

export default SettingsSummaryBlock
